import { render, staticRenderFns } from "./df-campaign-card.vue?vue&type=template&id=4baa016e&"
import script from "./df-campaign-card.ts?vue&type=script&lang=js&"
export * from "./df-campaign-card.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports